<template>
  <v-dialog v-model="importDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <v-layout row class="no-select global-not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">cloud_upload</v-icon>
            <span class="px-3">{{ $t('Import Excel File') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="grey lighten-3">
        <v-layout row wrap mb-3>
          <v-flex xs12>
            <v-btn :disabled="fileSelected" @click="chooseFile" color="blue-grey" class="white--text">
              {{ $t('Choose excel file') }}
            </v-btn>
            <v-chip v-if="fileSelected" :selected="fileSelected" @input="removeExcelFile()" close>{{
              fileName
            }}</v-chip>
            <input
              style="visibility:hidden; width:0; position:absolute; top:-9999px"
              type="file"
              name="file"
              ref="xlsref"
              @input="handleFile"
              v-validate="'size:2047|ext:xlsx'"
              data-vv-name="excel-file"
              :error="errors.has('excel-file')"
            />
          </v-flex>
          <v-flex pt-3 xs12>
            <span style="color: red">*</span>
            {{ $t('Please download sample file before import') }}
            <v-btn flat style="margin-left: 0px" small @click="downloadSampleTable" color="primary" class="white--text">
              {{ $t('Download sample') }}
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <span style="color: red">*</span>
            {{ $t('Maximum record of excel file should be less than 5000') }}
          </v-flex>

          <table id="sample-table" style="display: none" cellspacing="0">
            <thead>
              <tr>
                <th
                  v-for="(header, index) in tableHeader"
                  :key="index"
                  class="pa-2 view-table-header"
                  v-if="header.value.length > 1"
                >
                  {{ header.value }}
                </th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </v-layout>
      </v-card-title>

      <v-divider light />

      <v-card-actions class="grey lighten-3">
        <v-layout column>
          <v-layout justify-end>
            <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
            <v-btn :loading="btnLoading" :disabled="!fileSelected" @click="importExcel()" type="submit" color="success">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">cloud_upload</v-icon>
              {{ $t('Import') }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  props: {
    importDialog: { type: Boolean, required: true },
    tableHeader: { type: Array, required: true },
    importUrl: { type: String, required: true }
  },

  computed: {
    ...mapGetters({
      sectionTitle: 'dashboard/getAppBarTitle'
    })
  },

  data() {
    return {
      fileInput: null,
      theFile: null,
      importedFile: null,
      fileName: '',
      fileSelected: false,
      btnLoading: false
    }
  },

  methods: {
    formatImportedData(jsonData) {
      let columnNames = []
      let arrayContainer = []
      console.log(jsonData)

      jsonData.forEach((data, i) => {
        let key = ''
        for (let j = 0; j < Object.keys(data).length - 1; j++) {
          if (j === 0) {
            key = '__EMPTY'
          } else {
            key = '__EMPTY_' + j
          }
          if (i === 0) {
            // we should replace all spaces to underscore (_) and convert them to lowercase
            // to be like the column names in table
            columnNames.push(data[key].replace(/ /g, '_').toLowerCase())
            arrayContainer[data[key].replace(/ /g, '_').toLowerCase()] = []
          } else {
            arrayContainer[columnNames[j]].push(data[key])
          }
        }
      })
      console.log(arrayContainer)
    },

    chooseFile() {
      this.$refs.xlsref.click()
    },

    handleFile() {
      this.fileInput = this.$refs.xlsref
      this.theFile = this.fileInput.files[0]

      let reader = new FileReader()
      reader.onload = e => {
        let data = new Uint8Array(e.target.result)
        let workbook = XLSX.read(data, { type: 'array' })
        workbook.SheetNames.forEach(sheetName => {
          let jsonObjects = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
          this.importedFile = jsonObjects
        })
      }
      reader.readAsArrayBuffer(this.theFile)
      this.fileName = this.theFile.name
      this.fileSelected = true
    },

    downloadSampleTable() {
      var tbl = document.getElementById('sample-table')
      var ws = XLSX.utils.table_to_sheet(tbl)

      // this is to export json to excel
      // var ws = XLSX.utils.json_to_sheet(this.resultData.data)
      // var wscols = [{ width: 'auto' }, { width: 'auto' }] // this line and the line below is to
      // set the width for exported column
      // ws['!cols'] = wscols

      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, `${this.sectionTitle.title}`)
      XLSX.writeFile(wb, `${this.sectionTitle.title} ${this.$t('Sample')}.xlsx`)
    },

    removeExcelFile() {
      this.fileSelected = false
      this.fileInput = null
      this.theFile = null
      this.importedFile = null
      this.fileName = ''
      this.$refs.xlsref.value = ''
    },

    importExcel() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnLoading = true
          Axios.post(this.importUrl, this.importedFile)
            .then(() => {
              helpers.ktNotify({
                type: 'success',
                text: 'Imported Successfully'
              })
              this.removeExcelFile()
              this.btnLoading = false
              this.$emit('imported')
              this.$emit('hidemodal')
            })
            .catch(error => {
              this.btnLoading = false
              helpers.showErrorMessage(error, 'An error occurred, import failed')
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.global-only-for-print {
  display: none;
}
</style>
